/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var HtmlAttributes = /** @class */ (function () {
    function HtmlAttributes() {
    }
    HtmlAttributes.ariaInvalid = "aria-invalid";
    HtmlAttributes.ariaLabelledBy = "aria-labelledby";
    HtmlAttributes.editorBlockType = "data-editorblocktype";
    HtmlAttributes.dataRequired = "data-required";
    HtmlAttributes.dataRequiredForCancel = "data-requiredForCancel";
    HtmlAttributes.dataCountryCode = "data-countrycode";
    HtmlAttributes.dataReadableEventId = "data-readable-event-id";
    HtmlAttributes.dataDoNotTrack = "data-do-not-track";
    HtmlAttributes.dataNotificationName = "data-notification-name";
    /**
     * @deprecated Use formId instead
     * Needed for backward compatibility
     */
    HtmlAttributes.formBlockId = "data-form-block-id";
    HtmlAttributes.formId = "data-form-id";
    HtmlAttributes.formCachedUrl = "data-cached-form-url";
    /**
     * @deprecated formSubmitUrl is built from formApiBaseUrl
     * Needed for backward compatibility (if embedding script does not contain formApiBaseUrl)
     */
    HtmlAttributes.formSubmitUrl = "data-submit-form-url";
    HtmlAttributes.formApiBaseUrl = "data-form-api-url";
    return HtmlAttributes;
}());
export { HtmlAttributes };
